import { lerp, squaredDistance as squaredDx } from 'ol/math';
import { getLength } from 'ol/sphere';
import LineString from 'ol/geom/LineString';
import MultiLineString from 'ol/geom/MultiLineString'

function segmentLength(a, b) { const dx = b[0] - a[0]; const dy = b[1] - a[1]; return Math.hypot(dx, dy); }
function lerpCoord(a, b, t) { return [a[0] + (b[0] - a[0]) * t, a[1] + (b[1] - a[1]) * t]; }

function assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    var x1 = flatCoordinates[offset1];
    var y1 = flatCoordinates[offset1 + 1];
    var dx = flatCoordinates[offset2] - x1;
    var dy = flatCoordinates[offset2 + 1] - y1;
    var offset;
    if (dx === 0 && dy === 0) {
        offset = offset1;
    }
    else {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            offset = offset2;
        }
        else if (t > 0) {
            for (var i = 0; i < stride; ++i) {
                closestPoint[i] = lerp(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            }
            closestPoint.length = stride;
            return;
        }
        else {
            offset = offset1;
        }
    }
    for (var i = 0; i < stride; ++i) {
        closestPoint[i] = flatCoordinates[offset + i];
    }
    closestPoint.length = stride;
}

export function lineStringLengthToCoordinatesLine(flatCoordinates, offset, end, stride, x, y) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    var length = 0;
    
    var minSquaredDistance = Infinity;
    var lengthToThePoint = 0;
    var tmpPoint = [NaN, NaN];

    for (var i = offset + stride; i < end; i += stride) {

        assignClosest(flatCoordinates, i - stride, i, stride, x, y, tmpPoint);
        var squaredDistance = squaredDx(x, y, tmpPoint[0], tmpPoint[1]);
        if(squaredDistance < minSquaredDistance) {
            var x2 = tmpPoint[0];
            var y2 = tmpPoint[1];
            var l = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));

            lengthToThePoint = length + l;
            minSquaredDistance = squaredDistance;
        }
        
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }

    return lengthToThePoint;
}

export function sliceLineString(flatCoordinates, startM, endM) {

  // normalizace vstupů
  const start = Math.max(0, startM);
  const end = Math.max(0, endM);
  if (end <= start) return null;

  let acc = 0;                 // naběhlá vzdálenost po trase
  let out = [];                // výstupní souřadnice
  let started = false;

  for (let i = 0; i < flatCoordinates.length - 1; i++) {
    const a = flatCoordinates[i];
    const b = flatCoordinates[i + 1];
    const L = segmentLength(a, b);
    if (L === 0) continue;

    const segStart = acc;
    const segEnd = acc + L;

    // segment je celý před startem
    if (segEnd < start) {
      acc = segEnd;
      continue;
    }

    // segment je celý za endem a ještě jsme nezačali => hotovo (nic)
    if (segStart > end) break;

    // 1) pokud start leží uvnitř tohoto segmentu a ještě jsme nezačali
    if (!started && start >= segStart && start <= segEnd) {
      const tStart = (start - segStart) / L;     // 0..1
      out.push(lerpCoord(a, b, tStart));
      started = true;
    }

    // 2) pokud jsme začali, přidáme buď celý bod b (když je stále před end),
    // nebo interpolovaný koncový bod a skončíme
    if (started) {
      if (end >= segEnd) {
        // end je dál, takže bereme celý segment až do b
        out.push(b);
      } else {
        // end leží uvnitř segmentu
        const tEnd = (end - segStart) / L;
        out.push(lerpCoord(a, b, tEnd));
        break;
      }
    }

    acc = segEnd;
  }

  // ošetření: potřebujeme alespoň dva body
  if (!out || out.length < 2) return null;

  // pokud náhodou vyšla duplicita sousedních bodů, můžeš odfiltrovat:
  // (volitelné)
  const cleaned = [out[0]];
  for (let i = 1; i < out.length; i++) {
    const p = out[i], q = cleaned[cleaned.length - 1];
    if (p[0] !== q[0] || p[1] !== q[1]) cleaned.push(p);
  }

  return cleaned;
}

export function lineStringLengthToCoordinatesMultiLine(flatCoordinates, offset, ends, stride, x, y) {

    var minSquaredDistance = Infinity;
    var lengthToThePoint = 0;
    var tmpPoint = [NaN, NaN];
    
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        
        var x1 = flatCoordinates[offset];
        var y1 = flatCoordinates[offset + 1];
        var length = 0;
        
        for (var i = offset + stride; i < end; i += stride) {
            
            assignClosest(flatCoordinates, i - stride, i, stride, x, y, tmpPoint);
            var squaredDistance = squaredDx(x, y, tmpPoint[0], tmpPoint[1]);
            if(squaredDistance < minSquaredDistance) {
                var x2 = tmpPoint[0];
                var y2 = tmpPoint[1];
                var l = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));

                lengthToThePoint = length + l;
                minSquaredDistance = squaredDistance;
            }
            
            var x2 = flatCoordinates[i];
            var y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            x1 = x2;
            y1 = y2;

        }
        
        offset = end;
    }
    return minSquaredDistance;
}


LineString.prototype.getLengthToCoordinates = function (x, y) {
    var tmpPoint = [NaN,NaN];
    this.closestPointXY(x, y, tmpPoint, Infinity);
    return lineStringLengthToCoordinatesLine(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, tmpPoint[0], tmpPoint[1]);
};

MultiLineString.prototype.getLengthToCoordinates = function (x, y) {
    var tmpPoint = [NaN,NaN];
    this.closestPointXY(x, y, tmpPoint, Infinity);
    return lineStringLengthToCoordinatesMultiLine(this.flatCoordinates, 0, this.ends_, this.stride, x, y);
};


export function lineStringLengthToCoordinates(geometry, realLength, x, y) {
    if(geometry.getLengthToCoordinates) {
        var len =  geometry.getLengthToCoordinates(x, y);
        var geometryLength = geometry.getLength();
        return (len/geometryLength)*realLength;
    }
    return 0;
}


